import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { ShIconService } from '../../services/icon.service';
import { ShIconComponent } from './icon.component';

@NgModule({
    imports: [HttpClientModule, ShIconComponent],
    exports: [ShIconComponent]
})
export class ShIconModule {
    static forRoot(): ModuleWithProviders<ShIconModule> {
        return {
            ngModule: ShIconModule,
            providers: [ShIconService]
        };
    }
}

export * from './entities/icon-sizes.entity';
export { ShIconComponent } from './icon.component';
